import pageData from '@anm/data/video-templates/pages';

import getPageNumberSufix from '../getPageNumberSufix';
import { TemplateMetaProps } from '../types';

const getTemplatesMetaTitle = ({
  pageName,
  pageNumber,
  currentTemplate
}: TemplateMetaProps) => {
  const title = currentTemplate?.templateId
    ? currentTemplate.displayName
    : pageData[pageName].header.title_meta;

  const sufix = getPageNumberSufix(pageNumber);

  return `${title}${sufix} | Wave.video`;
};

export default getTemplatesMetaTitle;
